import React, {useEffect, useState} from "react";
import {Helmet} from "react-helmet";
import {Link} from "react-router-dom";
import store from "../Redux/store/store";

import LandingPageFamilyPhotoGrid from "../Components/LandingPageFamilyPhotoGrid";

import {fetchUserData, loginUser} from "../Redux/users/userSlice";

import useExitPrompt from "../Hooks/useExitPrompt";

import {Button, Grid, IconButton, Input, InputAdornment, useMediaQuery, useTheme} from "@mui/material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {Visibility, VisibilityOff} from "@mui/icons-material";

const Login = (props) => {
  const {buttonLoad} = props;
  const [, setShowExitPrompt] = useExitPrompt(false);
  const [showPass, setShowPass] = useState(false);
  const [agree, setAgree] = useState(false);
  const [agreementError, setAgreementError] = useState("");
  const {logoutMessage, loginError} = store.getState().users;
  const theme = useTheme();
  const hideImageText = useMediaQuery(theme.breakpoints.down("md"));
  const handleLogin = async (e) => {
    e.preventDefault();
    // Require agreement checkbox before allowing login
    if (!agree) {
      setAgreementError("You must agree before logging in.");
      return;
    }
    setAgreementError("");

    const {email, password} = e.target;
    const credentials = {email: email.value, password: password.value};
    await store
      .dispatch(loginUser(credentials))
      .then((res) => {
        store.dispatch(fetchUserData(store.getState().users.patientId));
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const handleShowPass = (e) => {
    e.preventDefault();
    setShowPass(!showPass);
  }

  useEffect(() => {
    setShowExitPrompt(false);
  }, []);

  return (
    <>
      <Helmet>
        <title>Welcome to DNAassist</title>
      </Helmet>
      <Grid container mt={5}>
        <LandingPageFamilyPhotoGrid />
        <Grid item xs={12} sm={12} md={6} className="loginForm"
              sx={hideImageText ? {borderRadius: "15px", zIndex: 5} : {zIndex: 5}}>
          <img className="img-logo"
               src={require("../Resources/Images/DNAA/logo.png")}
               alt="DNAassist Logo" /><br />
          <form onSubmit={(e) => handleLogin(e)}>
            <br /><br /><br />
            <h4 className="">Log In</h4><br />
            <label className="margintop20px">
              Email Address <br />
              {/**
               *  TODO: add a "remember email" checkbox
               */}
            </label>
            <Input name="email"
                   type="email"
                   placeholder="Email"
                   disableUnderline={true}
                   className="text-input-wide" />
            <br /><br />
            <label>
              Password <br />
            </label>
            <Input name="password"
                   type={`${showPass ? "text" : "password"}`}
                   placeholder="Password"
                   className="text-input-wide"
                   disableUnderline={true}
                   endAdornment={
                     <InputAdornment position={"end"}>
                       <IconButton onClick={handleShowPass}>
                         {showPass ? <Visibility /> : <VisibilityOff />}
                       </IconButton>
                     </InputAdornment>
                   }
            />
            <br /><br />
            <div className="agreement-text" style={{maxHeight: "160px", overflowY: "auto", padding: "10px", border: "1px solid #ccc", borderRadius: "8px"}}>
              <p>This system contains confidential and protected information, including PHI (Protected Health Information) and PII (Personally Identifiable Information).</p>
              <p>By proceeding, you acknowledge and agree that:</p>
              <ul style={{marginLeft: "16px"}}>
                <li>You are an authorized user and will access this system only for approved purposes.</li>
                <li>You will protect the confidentiality, integrity, and security of all information you access in accordance with HIPAA, HITRUST, and organizational policies.</li>
                <li>You will not disclose, copy, or use information in an unauthorized manner.</li>
                <li>All activity on this system is logged and monitored. Unauthorized access or misuse may result in disciplinary action, civil and/or criminal penalties.</li>
                <li>If you are not authorized to use this system, exit immediately.</li>
              </ul>
            </div>
            <div style={{marginTop: "10px"}}>
              <label style={{display: "flex", alignItems: "center", gap: "8px"}}>
                <input type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} />
                <span>I agree</span>
              </label>
            </div>
            <br />
            {
              (logoutMessage || loginError || agreementError) &&
              <div className="error-text">&nbsp;{`${agreementError ? agreementError : (logoutMessage ? logoutMessage : loginError)}`}</div>
            }
            <Grid container flexDirection={"column"}>
              <Link to={"/forgot-password"}>Forgot Password?</Link>
              <Grid item xs={4} sx={{marginLeft: "auto"}}>
                <Button type="submit"
                        variant="contained"
                        name="next"
                        disabled={!agree}
                        className={buttonLoad ? " button-loading" : ""}>
                  <span className="backcontinue-button-text">Log In </span>
                  <ArrowForwardIcon className="backcontinue-button-text" sx={{ml: 1}} />
                </Button>
              </Grid>
              <br /><br />
            </Grid>
            <br /><br />
            <div style={{margin: "0 auto", width: "fit-content"}}>Need an account? <Link to="/signup">Register
              today</Link></div>
          </form>
        </Grid>
      </Grid>
    </>)
};

export default Login;
